var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HorizontalSlider"},[_c('swiper',{ref:"mySwiper",staticClass:"HorizontalSlider-container",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.items),function(item,index){return _c('swiper-slide',{key:index},[_vm._t("item",null,{item:item})],2)}),_vm._v(" "),(_vm.show_pagination)?_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /~/vue-loader/lib/template-compiler?{"id":"data-v-448c396a","hasScoped":false,"buble":{"transforms":{}}}!/~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/vue/components/HorizontalSlider.vue
// module id = 416
// module chunks = 0